import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { useAuth } from "../../contexts/AuthContext";
import { TaskFilter, NewTaskFilter } from "../../types";

export function useCreateFilter() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (newFilter: NewTaskFilter): Promise<TaskFilter> => {
      if (!user) throw new Error("Not authenticated");
      const { data, error } = await supabase
        .from("task_filters")
        .insert({
          user_id: user.id,
          name: newFilter.name,
          date_filters: newFilter.date_filters,
          list_ids: newFilter.list_ids,
          priorities: newFilter.priorities,
          tag_ids: newFilter.tag_ids,
          work_hours_filter: newFilter.work_hours_filter ?? null,
          task_scope: newFilter.task_scope ?? "all",
        })
        .select()
        .single();
      if (error) throw error;
      return data as TaskFilter;
    },

    onSuccess: (created) => {
      queryClient.setQueryData<TaskFilter[]>(queryKeys.filters, (old) => [
        ...(old ?? []),
        created,
      ]);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useCreateFilter" } });
      toast.error("Failed to create filter. Please try again.");
    },
  });
}
